export default function ServiceFlow() {
  const steps = [
    {
      number: '①',
      title: '課題ヒアリング',
      subtitle: '（無料）',
      description: '現場の課題を丁寧にお聞きし、解決方法を見出します'
    },
    {
      number: '②',
      title: 'AI・IT活用提案',
      subtitle: '',
      description: '具体的な解決策と導入プランをご提案いたします'
    },
    {
      number: '③',
      title: 'PoC',
      subtitle: '',
      description: '小規模な実証実験で効果を確認し、リスクを最小化'
    },
    {
      number: '④',
      title: 'ツール開発',
      subtitle: '',
      description: '現場に最適化したAIツールを開発・カスタマイズ'
    },
    {
      number: '⑤',
      title: '導入・運用',
      subtitle: '',
      description: '導入後も継続的にサポートし、効果を最大化'
    }
  ];

  return (
    <section id="service" className="bg-white py-20">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <p className="text-[#4A5568] text-xs font-bold tracking-widest uppercase mb-4">SERVICE FLOW</p>
          <h2 className="text-4xl font-black text-[#1A3A5C]">ご支援の流れ</h2>
        </div>

        <div className="flex flex-col md:flex-row items-start justify-between gap-4">
          {steps.map((step, index) => (
            <div key={index} className="flex items-center w-full md:w-auto">
              <div className="bg-white rounded-xl shadow-md p-6 flex-1 md:w-48 hover:shadow-lg transition-shadow duration-300">
                <div className="w-14 h-14 bg-[#1A3A5C] rounded-full flex items-center justify-center mb-4 mx-auto">
                  <span className="text-white text-2xl font-bold">{step.number}</span>
                </div>
                <h3 className="text-[#1A3A5C] font-bold text-base text-center mb-1">
                  {step.title}
                </h3>
                <p className="text-[#4A5568] text-xs leading-relaxed text-center">{step.description}</p>
              </div>
              {index < steps.length - 1 && (
                <div className="hidden md:block mx-2">
                  <i className="ri-arrow-right-line text-2xl text-[#4A5568]"></i>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}